import { render, staticRenderFns } from "./VueAgricola.vue?vue&type=template&id=27dfdb17"
import script from "./VueAgricola.vue?vue&type=script&lang=js"
export * from "./VueAgricola.vue?vue&type=script&lang=js"
import style0 from "./VueAgricola.vue?vue&type=style&index=0&id=27dfdb17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports